async function createFingerprint() {
  const fingerprintJS = await import('@fingerprintjs/fingerprintjs')
  const fp = await fingerprintJS.load()
  const result = await fp.get()
  return fingerprintJS.murmurX64Hash128(result.visitorId)
}

let browserId = ''

async function loadBrowserId() {
  browserId = localStorage.getItem('browserId') || ''
  if (!browserId) {
    browserId = await createFingerprint()
    localStorage.setItem('browserId', browserId)
  }
}

export const getBrowserId = async () => {
  if (!browserId) {
    await loadBrowserId()
  }
  return browserId
}
